// extracted by mini-css-extract-plugin
export default {"PerformanceDisclosure":"PerformanceDisclosure_PerformanceDisclosure__Le6qy","text":"PerformanceDisclosure_text__yjkyI"};